// import React from "react";
// import "../privacypolicy/Privacypolicy.css";
// import Header from "../header/header";
// import Footer from "../footer/footer";

// const Refund = () => {
//   return (
//     <div>
//       <Header />
//       <div className="terms-page">
//         <h4>AstroBhagya Refund & Cancellation Policy</h4>
//          <p>
//          <b>AstroBhagya App</b>, developed and managed by <b>Heavenly Expectation Private
//           Limited</b>, offers trusted astrology services and personalized guidance
//           in a modern digital format.
//         </p>
//         <p>
//           At <strong>AstroBhagya</strong>, we are committed to providing
//           high-quality astrology services to our users. We understand that there
//           may be occasions when you wish to cancel a service or request a
//           refund. This Refund & Cancellation Policy explains the process in
//           detail, ensuring that our users understand their rights and the steps
//           to follow. By using our platform, you agree to the terms outlined in
//           this policy.
//         </p>

//         <h5>1. Cancellation of Services</h5>
//         <p>
//           We recognize that situations can arise where you may need to cancel a
//           service. To ensure fairness and transparency, AstroBhagya allows
//           service cancellations under specific conditions:
//         </p>
//         <ul>
//           <li>
//             <strong>Timeframe for Cancellation:</strong> You may request a
//             cancellation within 7 days of placing your order. Requests made
//             after this period may not be entertained.
//           </li>
//           <li>
//             <strong>Service Already Assigned:</strong> If the service has
//             already been assigned to an astrologer or scheduled for
//             consultation, your cancellation request may not be accepted. This
//             ensures that astrologers who have committed their time are fairly
//             compensated.
//           </li>
//           <li>
//             <strong>Service in Progress or Delivered:</strong> If your service
//             is already in progress or has been delivered, you cannot cancel it.
//             However, if you are dissatisfied with the service or experience
//             quality issues, you can raise a complaint under the “Damaged,
//             Defective, or Unsatisfactory Services” section of this policy.
//           </li>
//           <li>
//             <strong>Time-Sensitive Consultations:</strong> AstroBhagya does not
//             accept cancellations for time-sensitive consultations once the
//             astrologer has started the session. Examples include live horoscope
//             readings, remedial consultations, or any appointment scheduled for a
//             specific date and time.
//           </li>
//         </ul>

//         <p>
//           Cancellations help maintain the efficiency of the platform, but we
//           also aim to be flexible where genuine concerns exist.
//         </p>
//         <h5>2. Perishable or Instant Services</h5>
//         <p>
//           Certain services provided on <strong>AstroBhagya</strong> are instant
//           or digital in nature, such as:
//         </p>
//         <ul>
//           <li>Personalized astrology reports</li>
//           <li>Instant horoscope readings</li>
//           <li>Remedies or personalized advice delivered digitally</li>
//         </ul>
//         <p>
//           These services cannot be canceled once delivered, as they are
//           immediately accessible to the user. This policy ensures the integrity
//           of digital content and prevents misuse.
//         </p>
//         <p>
//           <strong>Refund Eligibility:</strong> Refunds or replacements may only
//           be considered if the user can demonstrate that there is a problem with
//           the quality, accuracy, or authenticity of the service. For example, if
//           the digital report contains errors or if the remedy provided does not
//           match what was promised on the platform, a refund or re-service may be
//           initiated.
//         </p>

//         <h5>3. Damaged, Defective, or Unsatisfactory Services</h5>
//         <p>
//           AstroBhagya strives to ensure all services meet high-quality
//           standards. However, if you receive a service that is:
//         </p>
//         <ul>
//           <li>Incorrect (not as described)</li>
//           <li>Defective (contains errors or is incomplete)</li>
//           <li>
//             Unsatisfactory (does not meet reasonable expectations based on the
//             description)
//           </li>
//         </ul>
//         <p>
//           You can report the issue to our Customer Support team within 7 days of
//           receiving the service.
//         </p>

//         <strong>Complaint Review Process:</strong>
//         <ul>
//           <li>
//             Once a complaint is lodged, AstroBhagya will review the details of
//             the service and the nature of your concern.
//           </li>
//           <li>
//             The platform will coordinate with the assigned astrologer or service
//             provider to verify the issue.
//           </li>
//           <li>
//             After verification, an appropriate resolution will be provided.
//           </li>
//         </ul>

//         <strong>Possible Resolutions:</strong>
//         <ul>
//           <li>
//             <strong>Full or Partial Refund:</strong> If the service was not
//             delivered as promised or contains verified errors, you may receive a
//             refund.
//           </li>
//           <li>
//             <strong>Re-service:</strong> In some cases, you may be offered a
//             repeat consultation or correction of the delivered service.
//           </li>
//           <li>
//             <strong>Replacement Service:</strong> If applicable, a replacement
//             service may be provided.
//           </li>
//         </ul>

//         <p>
//           All refunds or corrective actions are handled during working days
//           (Monday to Friday) to ensure proper coordination with astrologers and
//           our customer support team. Requests received on weekends or public
//           holidays will be processed on the next working day.
//         </p>
//         <h5>4. Services with Warranty or Guarantees</h5>
//         <p>
//           Certain services may come with a warranty or guarantee, either from
//           the astrologer or a third-party provider. This includes services that
//           promise:
//         </p>
//         <ul>
//           <li>A certain outcome or remedial effect</li>
//           <li>Follow-up support for a limited time</li>
//         </ul>
//         <p>
//           <strong>How to Claim:</strong> For services with warranties, users are
//           advised to contact the warranty provider directly. AstroBhagya may
//           assist in facilitating communication, but the warranty is governed by
//           the terms provided by the astrologer or third-party service provider.
//         </p>
//         <h5>5. Refund Processing</h5>
//         <p>
//           AstroBhagya aims to ensure that refunds are handled quickly and
//           fairly.
//         </p>
//         <strong>Processing Timeline:</strong>
//         <p>
//           Refunds approved by AstroBhagya will be processed within 7 working
//           days to the original payment method. This ensures sufficient time to
//           verify the issue, coordinate with the astrologer, and complete the
//           necessary financial transactions.
//         </p>
//         <strong>Deductions:</strong>
//         <p>
//           Refunds may be subject to applicable deductions according to platform
//           policies or agreements with the astrologer/service provider. Any
//           deductions will be clearly communicated to the user before processing
//           the refund.
//         </p>
//         <strong>Working Days:</strong>
//         <p>
//           Refunds are processed only on working days (Monday to Friday).
//           Requests received on weekends or holidays will be addressed on the
//           next working day. This ensures smooth and accurate handling of
//           payments and prevents errors.
//         </p>

//         <h5>6. How to Contact Customer Support</h5>
//         <p>
//           For any cancellations, refund requests, or complaints, AstroBhagya
//           provides multiple ways to reach our Customer Support team:
//         </p>
//         <ul>
//           <li>
//            <b> Email:</b>{" "}
//             <a href="mailto:business@astrobhagya.co.in">
//               business@astrobhagya.co.in
//             </a>
//           </li>
//         </ul>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default Refund;


import React from "react";
import "../privacypolicy/Privacypolicy.css";
import Header from "../header/header";
import Footer from "../footer/footer";

const Refund = () => {
  return (
    <div>
      <Header />
      <div className="terms-page">
        <h4>AstroBhagya Refund &amp; Cancellation Policy</h4>
        <p>
          <b>AstroBhagya App</b>, developed and managed by{" "}
          <b>Heavenly Expectation Private Limited</b>, offers trusted astrology
          services and personalized guidance in a modern digital format.
        </p>
        <p>
          At <strong>AstroBhagya</strong>, we are committed to providing
          high-quality astrology services to our users. We understand that there
          may be occasions when you wish to cancel a service or request a
          refund. This Refund &amp; Cancellation Policy explains the process in
          detail, ensuring that our users understand their rights and the steps
          to follow. By using our platform, you agree to the terms outlined in
          this policy.
        </p>

        {/* ───────────────────────── 1 ───────────────────────── */}
        <h5>1. Cancellation of Services</h5>
        <p>
          We recognize that situations can arise where you may need to cancel a
          service. To ensure fairness and transparency, AstroBhagya allows
          service cancellations under specific conditions:
        </p>
        <ul>
          <li>
            <strong>Timeframe for Cancellation:</strong> You may request a
            cancellation within 7 days of placing your order. Requests made
            after this period may not be entertained.
          </li>
          <li>
            <strong>Service Already Assigned:</strong> If the service has
            already been assigned to an astrologer or scheduled for
            consultation, your cancellation request may not be accepted. This
            ensures that astrologers who have committed their time are fairly
            compensated.
          </li>
          <li>
            <strong>Service in Progress or Delivered:</strong> If your service
            is already in progress or has been delivered, you cannot cancel it.
            However, if you are dissatisfied with the service or experience
            quality issues, you can raise a complaint under the "Damaged,
            Defective, or Unsatisfactory Services" section of this policy.
          </li>
          <li>
            <strong>Time-Sensitive Consultations:</strong> AstroBhagya does not
            accept cancellations for time-sensitive consultations once the
            astrologer has started the session. Examples include live horoscope
            readings, remedial consultations, or any appointment scheduled for a
            specific date and time.
          </li>
        </ul>
        <p>
          Cancellations help maintain the efficiency of the platform, but we
          also aim to be flexible where genuine concerns exist.
        </p>

        {/* ───────────────────────── 2 ───────────────────────── */}
        <h5>2. Perishable or Instant Services</h5>
        <p>
          Certain services provided on <strong>AstroBhagya</strong> are instant
          or digital in nature, such as:
        </p>
        <ul>
          <li>Personalized astrology reports</li>
          <li>Instant horoscope readings</li>
          <li>Remedies or personalized advice delivered digitally</li>
        </ul>
        <p>
          These services cannot be canceled once delivered, as they are
          immediately accessible to the user. This policy ensures the integrity
          of digital content and prevents misuse.
        </p>
        <p>
          <strong>Refund Eligibility:</strong> Refunds or replacements may only
          be considered if the user can demonstrate that there is a problem with
          the quality, accuracy, or authenticity of the service. For example, if
          the digital report contains errors or if the remedy provided does not
          match what was promised on the platform, a refund or re-service may be
          initiated.
        </p>

        {/* ───────────────────────── 3 ───────────────────────── */}
        <h5>3. Damaged, Defective, or Unsatisfactory Services</h5>
        <p>
          AstroBhagya strives to ensure all services meet high-quality
          standards. However, if you receive a service that is:
        </p>
        <ul>
          <li>Incorrect (not as described)</li>
          <li>Defective (contains errors or is incomplete)</li>
          <li>
            Unsatisfactory (does not meet reasonable expectations based on the
            description)
          </li>
        </ul>
        <p>
          You can report the issue to our Customer Support team within 7 days of
          receiving the service.
        </p>

        <strong>Complaint Review Process:</strong>
        <ul>
          <li>
            Once a complaint is lodged, AstroBhagya will review the details of
            the service and the nature of your concern.
          </li>
          <li>
            The platform will coordinate with the assigned astrologer or service
            provider to verify the issue.
          </li>
          <li>
            After verification, an appropriate resolution will be provided.
          </li>
        </ul>

        <strong>Possible Resolutions:</strong>
        <ul>
          <li>
            <strong>Full or Partial Refund:</strong> If the service was not
            delivered as promised or contains verified errors, you may receive a
            refund.
          </li>
          <li>
            <strong>Re-service:</strong> In some cases, you may be offered a
            repeat consultation or correction of the delivered service.
          </li>
          <li>
            <strong>Replacement Service:</strong> If applicable, a replacement
            service may be provided.
          </li>
        </ul>
        <p>
          All refunds or corrective actions are handled during working days
          (Monday to Friday) to ensure proper coordination with astrologers and
          our customer support team. Requests received on weekends or public
          holidays will be processed on the next working day.
        </p>

        {/* ───────────────────────── 4 ───────────────────────── */}
        <h5>4. Services with Warranty or Guarantees</h5>
        <p>
          Certain services may come with a warranty or guarantee, either from
          the astrologer or a third-party provider. This includes services that
          promise:
        </p>
        <ul>
          <li>A certain outcome or remedial effect</li>
          <li>Follow-up support for a limited time</li>
        </ul>
        <p>
          <strong>How to Claim:</strong> For services with warranties, users are
          advised to contact the warranty provider directly. AstroBhagya may
          assist in facilitating communication, but the warranty is governed by
          the terms provided by the astrologer or third-party service provider.
        </p>

        {/* ───────────────────────── 5 ───────────────────────── */}
        <h5>5. Refund Processing</h5>
        <p>
          AstroBhagya aims to ensure that refunds are handled quickly and
          fairly.
        </p>

        <strong>Processing Timeline:</strong>
        <p>
          Refunds approved by AstroBhagya will be processed within 7 working
          days to the original payment method. This ensures sufficient time to
          verify the issue, coordinate with the astrologer, and complete the
          necessary financial transactions.
        </p>

        <strong>Deductions:</strong>
        <p>
          Refunds may be subject to applicable deductions according to platform
          policies or agreements with the astrologer/service provider. Any
          deductions will be clearly communicated to the user before processing
          the refund.
        </p>

        <strong>Working Days:</strong>
        <p>
          Refunds are processed only on working days (Monday to Friday).
          Requests received on weekends or holidays will be addressed on the
          next working day. This ensures smooth and accurate handling of
          payments and prevents errors.
        </p>

        {/* ───────────────────────── 6 ───────────────────────── */}
        <h5>6. Recharge &amp; Refund Policy</h5>
        <p>
          Wallet recharges made on the platform are ordinarily non-refundable.
          Refund requests shall be reviewed only in exceptional circumstances,
          including verified technical malfunction, duplicate transaction, or
          payment gateway failure. Approval of any refund shall remain at the
          sole discretion of the Company after proper verification.
        </p>

        {/* ───────────────────────── 7 ───────────────────────── */}
        <h5>7. Usage of Consultation Minutes</h5>
        <p>
          Consultation minutes that have already been consumed for chat or call
          services are strictly non-refundable.
        </p>
        <p>
          Any remaining unused wallet balance after partial usage shall continue
          to remain available in the user's wallet for future consultations,
          subject to platform policies.
        </p>

        {/* ───────────────────────── 8 ───────────────────────── */}
        <h5>8. Complimentary / Promotional Chat</h5>
        <p>
          Any complimentary or promotional chat provided by the platform carries
          no monetary value. Such sessions are non-transferable and shall not be
          eligible for refund, adjustment, or compensation under any
          circumstances.
        </p>

        {/* ───────────────────────── 9 ───────────────────────── */}
        <h5>9. Fraudulent Activity &amp; Misuse</h5>
        <p>
          The following actions shall be treated as misuse of the platform:
        </p>
        <ul>
          <li>
            Creation of multiple accounts for availing promotional or referral
            benefits
          </li>
          <li>Abuse or repeated exploitation of free or discounted offers</li>
          <li>
            Submission of false, inaccurate, or misleading information
          </li>
        </ul>
        <p>
          In such instances, the Company reserves the right to deny refund
          requests, suspend services, withhold wallet balance where applicable,
          or permanently terminate the concerned account without prior notice.
        </p>

        {/* ───────────────────────── 10 ───────────────────────── */}
        <h5>10. How to Contact Customer Support</h5>
        <p>
          For any cancellations, refund requests, or complaints, AstroBhagya
          provides multiple ways to reach our Customer Support team:
        </p>
        <ul>
          <li>
            <b>Email:</b>{" "}
            <a href="mailto:business@astrobhagya.co.in">
              business@astrobhagya.co.in
            </a>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  );
};

export default Refund;
